module.exports = __webpack_public_path__ + "static/media/ms_bg_xxl.65668d80.png";